import { render, staticRenderFns } from "./PopupOverlay.vue?vue&type=template&id=385a9848&scoped=true&"
import script from "./PopupOverlay.vue?vue&type=script&lang=js&"
export * from "./PopupOverlay.vue?vue&type=script&lang=js&"
import style0 from "./PopupOverlay.vue?vue&type=style&index=0&id=385a9848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385a9848",
  null
  
)

export default component.exports